import { render, staticRenderFns } from "./settingDigikala.vue?vue&type=template&id=b0913b46&scoped=true&"
import script from "./settingDigikala.vue?vue&type=script&lang=js&"
export * from "./settingDigikala.vue?vue&type=script&lang=js&"
import style0 from "./settingDigikala.vue?vue&type=style&index=0&id=b0913b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0913b46",
  null
  
)

export default component.exports